// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PrimaryKeyRequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
const _associations = [
];

const _fieldDefs = [
			{
				title: 'filterMethodId',
				placeholder: null,
				key: 'filterMethodId',
				isPrimaryKey: true,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.filterMethodId,
				setter: (x, y) => x.filterMethodId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new PrimaryKeyRequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'code',
				placeholder: null,
				key: 'code',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.code,
				setter: (x, y) => x.code = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'name',
				placeholder: null,
				key: 'name',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.name,
				setter: (x, y) => x.name = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'operator',
				placeholder: null,
				key: 'operator',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.operator,
				setter: (x, y) => x.operator = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'content',
				placeholder: null,
				key: 'content',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.content,
				setter: (x, y) => x.content = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'placeholderText',
				placeholder: null,
				key: 'placeholderText',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.placeholderText,
				setter: (x, y) => x.placeholderText = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'hasValue',
				placeholder: null,
				key: 'hasValue',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.hasValue,
				setter: (x, y) => x.hasValue = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'sqlRepresentation',
				placeholder: null,
				key: 'sqlRepresentation',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.sqlRepresentation,
				setter: (x, y) => x.sqlRepresentation = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class FilterMethod extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
